export default

    class BreakdownController {

    constructor(resource) {
        this._baseUrl = 'breakdown';
        this._resource = resource;
    }

    getAllBreakdown({serviceTypeId = null, vehicleId = null, clientId = null} = {}){
        return this._resource(`breakdown`, {serviceTypeId: serviceTypeId, vehicleId: vehicleId, clientId: clientId == 'all' ? null : clientId})
                        .get()
                        .then(v =>  v, err => {throw(err);});
    }

    deleteBreakdownById(id){
        return this._resource(`breakdown/delete/${id}`).delete()
                        .then(v =>  v, err => {throw(err);})
    }

    createBreakdown(Breakdown){
        return this._resource(`breakdown`).save(Breakdown)
                    .then(v =>  v, err => {throw(err);});        
    }  

    updateBreakdown(Breakdown){
        return this._resource(`breakdown`).update(Breakdown)
        .then(v =>  v, err => {throw(err);})
    }

    getBreakdownType(){
        return this._resource(`breakdown-type`)
                        .get()
                        .then(v =>  v, err => {throw(err);});
    }

    getTypeCharge(){
        return this._resource(`type-charge`)
                        .get()
                        .then(v =>  v, err => {throw(err);});
    }

    getDataForCharge(){
        return this._resource(`breakdowndataforcharge`)
            .get()
            .then(v =>  v, err => {throw(err);});
    }
    
}